import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { isJsonString } from '../../utils/common';

// 描述
interface Card {
  // 标题
  title?: string;
  // 描述
  des?: string;
  // 封面
  src?: string;
  url?: string;
  // 按钮组
  btnGroup?: Btn[];
  // 封面的类型
  type?: CardType;
}

interface Btn {
  // 名称
  name?: string;
  param?: any;
}
// 卡片的类型  暂时只有图片和视频两种
type CardType = 'img' | 'video';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-card',
  styleUrls: ['./icc-card.component.less'],
  template: `
    <div class="card-container" [ngStyle]="{ width: width + 'px' }">
      <!-- 空状态 -->
      <nz-empty *ngIf="isEmpty()" style="margin:15px 0"></nz-empty>
      <div *ngIf="!isEmpty()" class="card-wrapper" [ngStyle]="{ width: groupNum * width + 'px', marginLeft: -offsetX + 'px' }">
        <ng-container *ngFor="let card of list; index as i">
          <div class="card-slider" [ngStyle]="{ width: width + 'px' }" [ngClass]="{ active: i === actIndex }">
            <div class="item" [ngStyle]="{ width: 80 * (1 / num) + '%' }" *ngFor="let item of card">
              <div class="header">
                <!-- 图片 -->
                <ng-container *ngIf="item.type === 'img'">
                  <img [src]="item.url || item.src" />
                </ng-container>
                <!-- 视频 -->
                <ng-container *ngIf="item.type === 'video'">
                  <p class="mask" *ngIf="loading">视频加载中<span class="loading-circle"></span></p>
                  <icc-video [url]="item.url || item.src" [disabled]="true" [showPoster]="true"></icc-video>
                </ng-container>
              </div>
              <div class="content">
                <p class="title" [nzTooltipTitle]="item.title" nzTooltipPlacement="top" nz-tooltip>{{ item.title }}</p>
                <div class="des" [innerHTML]="item.des" [nzTooltipTitle]="item.des" nzTooltipPlacement="top" nz-tooltip></div>
                <!-- 按钮组 -->
                <ng-container *ngIf="item.btnGroup">
                  <div class="btn" *ngFor="let btn of item.btnGroup" [nzTooltipTitle]="titleTemplate" nzTooltipPlacement="top" nz-tooltip>
                    {{ btn.text || btn.name }}
                    <ng-template #titleTemplate>
                      <span *ngIf="btn.action === 1 || btn.action === 3 || btn.action === 7">{{ btn.param.extInfo }}</span>
                      <a *ngIf="btn.action === 2" [href]="formatHttps(btn.param.link.longUrl)" target="_blank">
                        {{ btn.param.link.longUrl }}
                      </a>
                      <span *ngIf="btn.action === 4">获取用户终端位置</span>
                      <span *ngIf="btn.action === 5">{{ btn.param.map.currentTude }}</span>
                      <span *ngIf="btn.action === 6">共享终端信息</span>
                      <div *ngIf="btn.action === 8">
                        <label>日历标题：</label>
                        <span>{{ btn.param.calendarInfo && btn.param.calendarInfo.title ? btn.param.calendarInfo.title : '' }}</span>
                        <br />
                        <label>起止时间：</label>
                        <span>{{ btn.param.calendarInfo && btn.param.calendarInfo.startTime ? btn.param.calendarInfo.startTime + ' ~ ' : '' }}{{ btn.param.calendarInfo && btn.param.calendarInfo.endTime ? btn.param.calendarInfo.endTime : '' }}</span>
                      </div>
                    </ng-template>
                  </div>
                </ng-container>
              </div>

              <!-- 操作组 -->
              <div class="operate" *ngIf="editable">
                <i nz-icon nzType="edit" (click)="editHandle(item)" nzTheme="outline" nzTooltipTitle="编辑" nzTooltipPlacement="top" nz-tooltip></i>
                <div style="margin-left: 20px;" nz-icon nzType="delete" nzTheme="outline" nzTooltipTitle="删除" nzTooltipPlacement="top" nz-tooltip nz-popconfirm nzPopconfirmTitle="确认删除该卡片？" (nzOnConfirm)="removeHandle(item)" nzPopconfirmPlacement="top" nzPopconfirmShowArrow="false"></div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="arrow-wrapper" *ngIf="isOverflow()">
        <a href="javascript:;" class="arrow arrow-prev" (click)="prevFocusImg()"></a>
        <a href="javascript:;" class="arrow arrow-next" (click)="nextFocusImg()"></a>
      </div>
      <div class="pagination-wrapper" *ngIf="isOverflow()">
        <span class="dot" (click)="changCardGroup(i)" [ngClass]="{ active: i === actIndex }" *ngFor="let item of pagination; let i = index"></span>
      </div>
    </div>
  `,
})
export class IccCardComponent implements OnInit {
  // 是否可以编辑
  @Input() editable = true;
  // 封面的格式
  @Input() type: CardType = 'img';
  // 每组卡片的数量
  @Input() num = 4;
  // 容器宽度
  @Input() width = 1000;
  // 卡片列表
  @Input()
  set cardLists(v) {
    setTimeout(() => {
      // 初始化组件的时候将是卡片操作项param为json字符串的解析
      if (v && v.length > 0) {
        for (let n = 0; n < v.length; n++) {
          for (let i = 0; i < v[n].btnGroup.length; i++) {
            if (isJsonString(v[n].btnGroup[i].param)) {
              v[n].btnGroup[i].param = JSON.parse(v[n].btnGroup[i].param);
            }
          }
        }
      }
      this.list = this.splitArray(v);
      this.groupNum = this.getGroups(v.length, this.num);
      console.log(`this.list`, this.list);
    }, 0);
  }
  get cardLists() {
    return this.list;
  }
  // 删除卡片的回调
  @Output() removeEvent = new EventEmitter<any>();
  // 编辑卡片的回调
  @Output() editEvent = new EventEmitter<any>();

  // 卡片
  list: Card[] = [];
  // 当前激活组
  actIndex = 0;
  // 组数
  groupNum = 0;
  // 偏移量
  get offsetX() {
    return this.width * this.actIndex;
  }
  // 分页
  get pagination() {
    return new Array(this.groupNum);
  }
  // 视频封面加载进度
  loading = true;
  constructor() {}

  ngOnInit() {}

  // 分组
  splitArray(list: any[]): any[] {
    let result = [];
    for (let i = 0; i < list.length; i += this.num) {
      result.push(list.slice(i, i + this.num));
    }
    return result;
  }
  getGroups(len: number, group: number): number {
    return Math.ceil(len / group);
  }

  editHandle(item: any): void {
    this.editEvent.next(item);
  }
  removeHandle(item: any): void {
    this.removeEvent.next(item);
  }
  // 视频加载完成
  canplaythrough() {
    this.loading = false;
  }
  // 是否有数据
  isEmpty(): boolean {
    return this.list.length < 1;
  }
  // 是否超过一屏
  isOverflow(): boolean {
    return this.list.length > 1;
  }

  // 切换组
  changCardGroup(index): void {
    this.actIndex = index;
  }
  // 上一张
  prevFocusImg(): void {
    const result = --this.actIndex < 0 ? this.groupNum - 1 : this.actIndex--;
    this.changCardGroup(result);
  }
  // 下一张
  nextFocusImg(): void {
    const result = ++this.actIndex >= this.groupNum ? 0 : this.actIndex++;
    this.changCardGroup(result);
  }
  // 处理URL的https前缀
  formatHttps(url) {
    const httpsReg = /^https:\/\//i;
    const httpReg = /^http:\/\//i;
    if (httpsReg.test(url)) {
      return url;
    } else if (httpReg.test(url)) {
      return url;
    } else {
      return 'https://' + url.replace(/^https:\/\//i, '');
    }
  }
}
